import { useEffect, useState } from 'react';

export const useURLParams = () => {
  const [code, setCode] = useState<string | null>(null);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const codeParam = urlParams.get('code');
    setCode(codeParam);
  }, []);

  return { code };
};